export const logRocketApiKey: string = 'xjnijt/test';
